import React from 'react';
import Button from '../../ui/buttons/Button';
import BeneficiaryForm from './BeneficiaryForm';

const newTempId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const BeneficiariesFormList = ({ beneficiaries, onChange, canWrite = true }) => {
  const visible = beneficiaries.map((b, originalIndex) => ({ ...b, _idx: originalIndex })).filter((b) => !b._destroy);

  const handleChange = (originalIndex, updated) => {
    const updatedList = [...beneficiaries];
    updatedList[originalIndex] = updated;
    onChange(updatedList);
  };

  const handleAdd = () => {
    onChange([
      ...beneficiaries,
      {
        tempId: newTempId(),
        name: '',
        cpf: '',
        kinship: '',
        birthDate: '',
        _destroy: false,
      },
    ]);
  };

  const handleRemove = (originalIndex) => {
    const updatedList = [...beneficiaries];
    const item = updatedList[originalIndex];

    if (item?.id) {
      updatedList[originalIndex] = { ...item, _destroy: true };
    } else {
      updatedList.splice(originalIndex, 1);
    }
    onChange(updatedList);
  };

  return (
    <>
      <div className="space-y-4 bg-tealWhisper rounded-xl border border-tealPale p-5">
        {visible.map(({ _idx, ...beneficiary }) => (
          <div
            key={beneficiary.id || beneficiary.tempId}
            className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6"
          >
            <BeneficiaryForm
              index={_idx} // índice do array original
              beneficiary={beneficiary}
              onChange={handleChange}
              onRemove={handleRemove}
              canWrite={canWrite}
            />
          </div>
        ))}
      </div>

      {canWrite && (
        <div className="pt-4">
          <Button onClick={handleAdd} type="button">
            + ADICIONAR BENEFICIÁRIO
          </Button>
        </div>
      )}
    </>
  );
};

export default BeneficiariesFormList;
